
    import { CommonEnvironment } from "./environment.common";
    export const environment = {
        ...CommonEnvironment,
        production: false,
        brand: 'nb',
        stage: 'local',
        appUrl: 'http://localhost:4200/',
        apiBaseUrl: 'http://localhost:9090/',
        apiKey: 'not required'
    }
